<template>
  <section class="board" style="background: #f9fbfe">
    <div class="wrapper">
      <animated-cloud class="board__cloud" :duration="3" />
      <animated-cloud class="board__cloud" :duration="5" />
      <animated-cloud class="board__cloud" :duration="4" />
      <animated-cloud class="board__cloud" :duration="3" />
      <!--- CRISTHMAS --->
      <!-- 
      <animated-christmas class="board__christmas" :duration="3" image="showman_left" />
      <animated-christmas class="board__christmas" :duration="5" image="cane_left" />
      <animated-christmas class="board__christmas" :duration="4" image="showman_right" />
      <animated-christmas class="board__christmas" :duration="3" image="cane_right" /> 
      -->
    </div>
  </section>
</template>

<script>
import AnimatedCloud from "@/app/common/components/molecules/AnimatedCloud.vue";
// import AnimatedChristmas from "@/app/common/components/molecules/AnimatedChristmas.vue";

export default {
  components: {
    AnimatedCloud,
    // AnimatedChristmas,
  },
};
</script>

<style lang="sass" scoped>
.board
  position: absolute
  left: 0
  right: 0
  bottom: 0
  top: 0
  z-index: -1

  &__cloud
    &:nth-child(1)
      width: 10rem
      position: absolute
      left: 0
      top: 30%

    &:nth-child(2)
      width: 6rem
      position: absolute
      left: 10rem
      top: 15%

    &:nth-child(3)
      width: 6rem
      position: absolute
      right: 10rem
      top: 15%

    &:nth-child(4)
      width: 10rem
      position: absolute
      right: 0
      top: 30%

  &__christmas
    &:nth-child(1)
      width: 8rem
      position: absolute
      left: 4rem
      top: 52%

    &:nth-child(2)
      width: 8rem
      position: absolute
      left: 10rem
      top: 12%

    &:nth-child(3)
      width: 10rem
      position: absolute
      right: 10.5rem
      top: 12%

    &:nth-child(4)
      width: 8rem
      position: absolute
      right: 5rem
      top: 52%

.wrapper
  width: 100%
  height: 100%
  max-width: 1200px
  margin: 0 auto
  position: relative
</style>
